import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { ScrollableShadowComponent } from '@pp/common';

import { CONDITIONS_AND_FEES } from './conditions-and-fees.entities';

@Component({
  selector: 'pp-conditions-and-fees-dialog',
  imports: [CommonModule, TranslateModule, ScrollableShadowComponent],
  templateUrl: './conditions-and-fees-dialog.component.html',
  styleUrl: './conditions-and-fees-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConditionsAndFeesDialogComponent {
  readonly conditions = CONDITIONS_AND_FEES;
}
